import { rest } from 'msw'
import { TCMockDataBuilder } from './TCMockDataBuilder'

// TODO: Not an IDEAL -- but we should look into
// regex for a better way to dynamically match path without
// worrying about hosts.
const allMatcherMethod = (uri) => {
  return `${process.env.VUE_APP_API_URL}/${uri}`
}

const state = {
  orders: {}
}

export const handlers = [
  rest.get(allMatcherMethod('sv/:svCode/order-info'), (_, res, ctx) => {
    return res(
      ctx.json(
        TCMockDataBuilder.mockOrderInfo.asRewardLink().buildResponse()
      )
    )
  }),
  rest.get(allMatcherMethod('sv/:svCode'), (_, res, ctx) => {
    if (!state.storedValue) {
      state.storedValue = TCMockDataBuilder.mockRewardLink.asRewardLink()
    }
    return res(ctx.json(state.storedValue.buildResponse()))
  }),
  rest.get(allMatcherMethod('sv/:svCode/catalog'), (_, res, ctx) => {
    if (!state.catalog) {
      state.catalog = TCMockDataBuilder.mockCatalog.init()
        .withEcardVariableBrands(10)
        .withEcardFixedBrands()
        .withDonationBrands(6)
        .buildResponse()
    }
    return res(
      ctx.json(state.catalog)
    )
  }),
  rest.post(allMatcherMethod('order/:svCode/externalRefId/:externalReferenceId'), (req, res, ctx) => {
    const order = TCMockDataBuilder.mockOrder.init().clearLineItems()
    req.body.lineItems.forEach(lineItem => {
      order.addLineItemFromBrandItem(
        state.catalog?.brands.find(brand => {
          return brand.items.some(item => item.utid === lineItem.utid)
        })?.items.find(item => item.utid === lineItem.utid)
        , lineItem.amount
      )
    })
    const response = order.buildResponse()
    state.orders[response.referenceOrderID] = order
    return res(ctx.json(order.buildResponse()))
  }),
  rest.get(allMatcherMethod('order/validation-rules'), (_, res, ctx) => {
    return res(ctx.json({}))
  }),
  rest.get(allMatcherMethod('sv/:svCode/recipient-info'), (_, res, ctx) => {
    return res(
      ctx.json({
        redemptionCounts: {
          firstRedemptionOccurredAt: undefined,
          lastRedemptionOccurredAt: undefined,
          countOfTotalRedemptions: 0,
          countOfRedemptionsSinceConfiguredCutoff: 0
        }
      })
    )
  }),
  rest.get(allMatcherMethod('order/:svCode/externalRefId/:cartExternalRefId/status'), (req, res, ctx) => {
    const orderResponse = state.orders[req.params.cartExternalRefId].setOrderComplete().buildResponse()
    state.storedValue = state.storedValue.withAvailableAmount(state.storedValue.buildResponse().availableAmount - orderResponse.orderTotal.value)
    return res(ctx.json(orderResponse))
  }),
  rest.get(allMatcherMethod('redemption-history'), (_, res, ctx) => {
    const redemptionHistory = TCMockDataBuilder.mockRedemptionHistory.init()
    Object.values(state.orders).forEach(order => {
      redemptionHistory.addFromOrder(order.buildResponse())
    })
    return res(ctx.json(redemptionHistory.buildResponse()))
  })
]
